import React, { ReactElement, useState, useEffect } from 'react';
import { Activite } from '../../../../../common/src/entities';
import { ArrayHelpers, useFormikContext } from 'formik';
import getImageUrl, { getThumbnailsImageUrl } from '../../../Utils/getFileURL';
import { Button, Form, Modal } from 'react-bootstrap';
import { BiX, BiDownload, ImYoutube, FiEyeOff, FiEye } from 'react-icons/all';
import TooltipSimple from '../../Common/TooltipSimple';
import ChampMultipleImageDnd from './ChampMultipleImageDnd';
import Images from '../../../../../common/src/entities/image.entity';
import Axios from 'axios';
import fileDownload from 'react-file-download';
var urlVideo = '';

function addUrlFormatEmbed() {
    if (urlVideo.includes('&')) {
        const idx = urlVideo.indexOf('&');
        urlVideo = urlVideo.slice(0, idx);
    }
    if (urlVideo.includes('youtu.be')) {
        urlVideo = urlVideo.replace('youtu.be/', 'www.youtube-nocookie.com/embed/');
    } else {
        urlVideo = urlVideo.replace('watch?v=', 'embed/');
        urlVideo = urlVideo.replace('youtube.com', 'youtube-nocookie.com');
    }
}

function AffichageAjout(props: { helpers: ArrayHelpers; values: Images[] }): ReactElement {
    const [showModal, setShowModal] = useState(false);
    var handleClose = () => setShowModal(false);
    var handleSuccess = () => {
        addVideoBd();
        setShowModal(false);
    };
    const { helpers, values } = props;

    function handleChange(event) {
        urlVideo = event.target.value;
    }

    function addVideoBd() {
        addUrlFormatEmbed();
        helpers.push({
            fk_id_activite: activite.id,
            fk_id_fichier: undefined,
            fichiers: {
                id: -1 * (values.length + 1),
                name: urlVideo,
                base64: 'data:image/jpeg;base64,',
            },
        });
    }
    const { values: activite } = useFormikContext<Activite>();
    return (
        <>
            <>
                <Form.File>
                    <Form.File.Label className="m-0">
                        <a className="btn btn-outline-primary btn-sm">Ajouter une image</a>
                    </Form.File.Label>
                    <Form.File.Input
                        className="d-none"
                        accept="image/*"
                        onChange={(event) => {
                            if (event.target.files && event.target.files.length > 0) {
                                const file = event.target.files[0];
                                const reader = new FileReader();
                                reader.addEventListener('load', () =>
                                    helpers.push({
                                        fk_id_activite: activite.id,
                                        fk_id_fichier: undefined,
                                        fichiers: {
                                            id: -1 * (values.length + 1),
                                            name: file.name,
                                            base64: reader.result,
                                        },
                                    }),
                                );
                                reader.readAsDataURL(file);
                            }
                        }}
                        multiple={true}
                    />
                </Form.File>
                <form>
                    <a className="btn btn-outline-primary btn-sm ml-2" onClick={() => setShowModal(true)}>
                        Ajouter une vidéo
                    </a>
                </form>
            </>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajout de l'URL</Modal.Title>
                </Modal.Header>
                <Form.Control placeholder="Entrez l'URL de la vidéo" onChange={handleChange} />
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSuccess}>
                        Ajouter
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
const affichageAjout = (values: Images[], helpers: ArrayHelpers) => (
    <AffichageAjout helpers={helpers} values={values} />
);

function download(url: string, filename: string) {
    Axios.get(url, {
        responseType: 'blob',
    }).then((res) => {
        fileDownload(res.data, filename);
    });
}

const AffichageElement = (props: { value: Images; index: number; helpers: ArrayHelpers }): ReactElement => {
    const { value, index, helpers } = props;
    const { remove } = helpers;
    const { setFieldValue, getFieldProps } = useFormikContext<Activite>();

    const toggleImageVisibility = (id) => {
        // Find the index of the fichier with the specified name
        const fichiers = getFieldProps('fichiers').value;
        const index = fichiers.findIndex((fichier) => fichier.fichiers.id === id);
        if (index !== -1) {
            const newFichiers = [...fichiers];

            newFichiers[index] = {
                ...newFichiers[index],
                ignorer: !newFichiers[index].ignorer,
            };
            // Update the Formik field value for the thematiques array (this will trigger a re-render)
            setFieldValue('fichiers', [...newFichiers]);
        }
    };

    function isVideo() {
        return value.fichiers.name.includes('embed');
    }

    return (
        <div className="px-2 ">
            <TooltipSimple texte={value.fichiers.name}>
                {isVideo() ? (
                    <div style={{ borderRadius: '5px', overflow: 'hidden', width: '100%', pointerEvents: 'none' }}>
                        <iframe
                            style={{ border: 'rounded' }}
                            src={value.fichiers.name}
                            width="200px"
                            height="150px"
                            title="Video Youtube"
                        ></iframe>
                    </div>
                ) : (
                    <img
                        width="200px"
                        height="150px"
                        src={getThumbnailsImageUrl(value.fichiers)}
                        className={`rounded ${value.ignorer ? 'opacity50' : ''}`}
                    />
                )}
            </TooltipSimple>
            <div className="d-flex justify-content-between">
                <TooltipSimple texte="Supprimer">
                    <Button variant="link" className="text-muted" onClick={() => remove(index)}>
                        <BiX size="1.25em" />
                    </Button>
                </TooltipSimple>
                <div>
                    <TooltipSimple texte={value.ignorer ? 'Masquer' : 'Afficher'}>
                        <Button
                            variant="link"
                            onClick={() => {
                                toggleImageVisibility(value.fichiers.id);
                            }}
                        >
                            {value.ignorer && <FiEyeOff size="1.25em" style={{ color: 'gray' }} />}
                            {!value.ignorer && <FiEye size="1.25em" />}
                        </Button>
                    </TooltipSimple>
                </div>
                {isVideo() ? (
                    <TooltipSimple texte="Aller sur Youtube">
                        <Button variant="link" onClick={() => goToYoutube(getIDVideo(value.fichiers.name))}>
                            <ImYoutube size="1.25em" />
                        </Button>
                    </TooltipSimple>
                ) : (
                    <TooltipSimple texte="Télécharger">
                        <Button
                            variant="link"
                            onClick={() => download(getImageUrl(value.fichiers), value.fichiers.name)}
                        >
                            <BiDownload size="1.25em" />
                        </Button>
                    </TooltipSimple>
                )}
            </div>
        </div>
    );
};
function goToYoutube(videoUrl: string) {
    const youtubeUrl = `https://www.youtube.com/watch?v=${videoUrl}`;
    window.open(youtubeUrl, '_blank');
}

function getIDVideo(url: string) {
    const indexDernierBackslash = url.lastIndexOf('/');
    let sousChaine = url.substring(indexDernierBackslash + 1);

    return sousChaine;
}
function affichageElement(sendValue: Images | number, index: number, helpers: ArrayHelpers): ReactElement {
    const value = sendValue as Images;
    return <AffichageElement {...{ value, index, helpers }} />;
}

export interface PropsChampMultipleImage {
    id: string;
    onRemove?: (index: number) => void;
    labelCol?: number;
}

export default function ChampMultipleImage(props: PropsChampMultipleImage): ReactElement {
    return (
        <ChampMultipleImageDnd
            labelCol={props.labelCol}
            entite={Images}
            titre="Images et vidéos"
            {...props}
            affichageElement={affichageElement}
            affichageAjout={affichageAjout}
        />
    );
}
